import React from 'react';
import './About.css';

function About() {
  return (
  <div className="about">
    <section id="section1" className="card">
      <p>
          Hi there! I'm Max Liu, a junior at Brown University.
          I made this website to document how I learned deep learning
          from a compliation of videos and articles.
      </p>
    </section>
  </div>);
}
export default About;
